<template>
	<div class="cluster">
		<div class="view-title">
			<translate>Cluster List</translate>
		</div>
		<div class="cluster-wrapper">
			<div class="add-cluster">
				<a href="javascript:;" @click.stop="onShowCreateCluster()">
					<i class="el-icon-plus"></i>
					<translate>New cluster</translate>
				</a>
				<div class="pull-right">
					<el-form :inline="true" class="demo-form-inline">
						<el-select v-model="search.condition" :placeholder="attrText.select" class="searchSelect" @change="clearSearchInput">
							<el-option :label="attrText.name" value="q_name"></el-option>
						</el-select>
						<el-input class="searchInput" v-model.trim="search.name" :disabled="!search.condition" @keyup.enter.native="onSearch()"></el-input>
						<el-button class="search-btn" @click="onSearch">
							<translate>Search</translate>
						</el-button>
					</el-form>
				</div>
			</div>
			<el-table :data="cluster.list" style="width: 100%" :show-header="false" :row-class-name="tableRowClassName" v-loading="loading">
				<el-table-column prop="name">
					<template scope="scope">
						<router-link :to="{ name: 'clusterDetail', params: { id: scope.row.id }, query: { type: scope.row.agent_version ? (isNewVersion(scope.row.agent_version) || scope.row.parent_id ? 'ecs' : 'settings') : 'settings' } }">
							<el-button type="text">
								{{ scope.row.name }}
							</el-button>
						</router-link>
						<span v-if="scope.row.parent_id" class="share-cluster">
							{{ `( ${scope.row.parent_company.full_name} )` }}
							<el-tooltip class="item" effect="dark" :content="attrText.shareCluster" placement="top">
								<i class="fa fa-share-alt-square"></i>
							</el-tooltip>
						</span>
					</template>
				</el-table-column>
				<el-table-column>
					<template scope="scope">
						<span :class="scope.row.agent_status === 1 ? 'available' : 'unavailable'">
							<i class="fa fa-lg" :class="scope.row.agent_status === 1 ? 'fa-check-circle-o' : 'fa-times-circle-o'"></i>
							{{ scope.row.agent_status === 1 ? attrText.available : attrText.unavailable }}
						</span>
					</template>
				</el-table-column>
				<el-table-column width="120">
					<template scope="scope">
						{{ getTranTest(scope.row.resource_count) }}
					</template>
				</el-table-column>
				<el-table-column>
					<template scope="scope">
						<p v-if="scope.row.agent_version && !isNewVersion(scope.row.agent_version) && !scope.row.parent_id">
							<i class="el-icon-warning" style="color: #fda541; font-size: 14px; top: 2px"></i>
							<translate style="color: #fda541">The current control node agent is lower, please update</translate>
						</p>
						<p v-if="!scope.row.agent_version || isNewVersion(scope.row.agent_version) || scope.row.parent_id">-</p>
					</template>
				</el-table-column>
				<el-table-column width="150" class="text-right">
					<template scope="scope">
						<el-button type="text" @click="exportCluster(scope.row.project_id)">
							<translate>Export</translate>
						</el-button>
						<router-link :to="{ name: 'clusterDetail', params: { id: scope.row.id }, query: { type: scope.row.agent_version ? (isNewVersion(scope.row.agent_version) || scope.row.parent_id ? 'ecs' : 'settings') : 'settings' } }">
							<el-button type="text">
								<translate>Details</translate>
							</el-button>
						</router-link>
						<el-button type="text" @click="returnCluster(scope.row.id)" v-if="scope.row.parent_id">
							<translate>Return</translate>
						</el-button>
						<el-button type="text" :loading="scope.row.deleting" @click.stop="deleteCluster(scope.row)" v-if="!scope.row.parent_id">
							<translate v-if="!scope.row.deleting">Delete</translate>
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination" v-if="cluster.totalPage > 10">
				<el-pagination layout="total, prev, pager, next" :total="cluster.totalPage" :page-size="10" :current-page.sync="cluster.currentPage" @current-change="onChangePage"></el-pagination>
			</div>
		</div>
		<!--创建集群-->
		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="getClusterList"></component>
	</div>
</template>

<script>
import STORE_CONST from '../../store/consts'
import CreateCluster from './model/cluster-add'
import Utility from '../../Utils'
import { baseUrl } from '../../config'

export default {
	data() {
		return {
			loading: false,
			cluster: {
				count: 0,
				list: [],
				detail: {},
				isDetail: false,
				totalPage: 0,
				currentPage: 1,
			},
			search: {
				condition: 'q_name',
				name: '',
				params: [],
			},
			currentRightPanel: null,
			rightPanelData: null,
			intervalId: '',
		}
	},
	computed: {
		attrText() {
			return this.getAttrText()
		},
		newAgentversion() {
			return this.$store.getters.cluster.newAgentVersion
		},
	},
	created() {
		this.getClusterList()
		//      this.intervalId = setInterval(() => {
		//        this.getClusterList(this.cluster.currentPage)
		//      }, 60000)
	},
	methods: {
		getTranTest(number) {
			let translated = this.$ngettext('%{ n } resource', '%{ n } resources', number)
			let interpolated = this.$gettextInterpolate(translated, { n: number })
			return interpolated
		},
		// get attr tanslate text
		getAttrText() {
			return {
				unavailable: this.$gettext('Unavailable'),
				available: this.$gettext('Available'),
				shareCluster: this.$gettext('shared cluster'),

				inputName: this.$gettext('Please input WokGroup Name'),
				defaultWorkgroup: this.$gettext('default workgroup'),
				select: this.$gettext('select'),
				name: this.$gettext('Name'),
			}
		},
		isNewVersion(version) {
			return !Utility.Utils.isNeedUpdate(version, this.newAgentversion)
		},
		// 获取集群列表
		getClusterList(page, total) {
			if (!this.cluster.list.length) {
				this.loading = true
			}
			let params = {
				params: {
					page: page || 1,
				},
			}
			if (this.search.name !== '' && this.search.condition) {
				params.params[this.search.condition] = this.search.name
			}
			if (total) {
				params.params.total = total
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_CLUSTER, params).then((res) => {
				this.loading = false
				this.cluster.list = res.objects
				this.cluster.totalPage = res.total
			})
		},
		// 导出集群
		exportCluster(id) {
			// this.downloadUrl = baseUrl.apiUrl + '/project/' + this.$route.params.id + '/hosts?type=ansible&export=true&t=' + new Date().getTime()
			window.open(baseUrl.apiUrl + '/v1/project/resources/export/' + id, '__blank')
		},
		// 退回集群
		returnCluster(id) {
			this.$confirm(this.$gettext('Return the current network?'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				this.$store
					.dispatch(STORE_CONST.CLUSTER.DELETE, id)
					.then(() => {
						this.$notify({
							type: 'success',
							message: this.$gettext('Return successfully!'),
						})
						this.getClusterList(this.cluster.currentPage)
					})
					.catch((err) => {
						this.$notify.info({
							message: err,
						})
					})
			})
		},
		// 搜索
		onSearch() {
			this.getClusterList()
		},
		// 清空搜索框
		clearSearchInput() {
			this.search.name = ''
		},
		// 删除集群
		deleteCluster(row) {
			this.$confirm(this.$gettext('Are you sure to delete the cluster?'), this.$gettext('Delete Prompt'), {
				confirmButtonText: this.$gettext('Comfirm'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			})
				.then(() => {
					this.$set(row, 'deleting', true)

					this.$store
						.dispatch(STORE_CONST.CLUSTER.DELETE, row.id)
						.then(() => {
							this.getClusterList(this.cluster.currentPage)
							this.$notify({
								type: 'success',
								message: this.$gettext('Delete successfully!'),
							})
						})
						.finally(() => {
							this.$set(row, 'deleting', false)
						})
				})
				.catch(() => {
					this.$set(row, 'deleting', false)
				})
		},
		// 分页
		onChangePage(page) {
			this.getClusterList(page, this.cluster.totalPage)
		},
		tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row'
			}
			return ''
		},
		// 关闭侧滑回调
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},
		// 显示创建集群
		onShowCreateCluster() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'CreateCluster' ? 0 : 300
			this.currentRightPanel = CreateCluster
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = {
						name: {
							label: this.$gettext('Cluster Name'),
							labelWidth: 280,
							val: '',
							rule: [
								{
									required: true,
									message: this.$gettext('Please input the cluster name'),
									trigger: 'blur',
								},
								{ max: 50, message: this.$gettext('length is within 50 characters'), trigger: 'change' },
							],
						},
						tips: {
							type: 'tips',
							text: this.$gettext('Note: A cluster can add up to 1000 resources'),
						},
					}
				}, time)
			})
		},
	},
	beforeRouteLeave(to, from, next) {
		window.clearInterval(this.intervalId)
		next()
	},
	components: {
		CreateCluster,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.cluster {
	.cluster-wrapper {
		padding: 15px;
		.cell {
			a {
				color: $textColor;
				.el-button--text {
					max-width: calc(100% - 10px);
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				&:hover {
					color: $mainColor;
				}
			}
		}
		.share-cluster {
			margin-left: 5px;
			color: $textColor;
		}
		.add-cluster {
			height: 60px;
			line-height: 60px;
			padding: 0 15px;
			background-color: #fff;
			border: 1px solid $border-color;
			border-bottom: none;
			a {
				color: $textColor;
				.el-icon-plus {
					font-weight: 700;
					font-size: 12px;
					margin-right: 4px;
				}
				&:hover {
					color: $mainColor;
					text-decoration: none;
				}
			}
			.pull-right {
				.searchInput {
					width: 180px;
				}
				.search-btn {
					height: 32px;
					min-width: 88px;
					padding: 0;
				}
				.searchSelect {
					width: 100px;
				}
			}
		}
		.available {
			font-size: 12px;
			color: $available;
		}
		.unavailable {
			font-size: 12px;
			color: $unavailable;
		}
		.el-checkbox {
			margin-bottom: 0;
			margin-left: 10px;
			.el-checkbox__inner {
				width: 14px;
				height: 14px;
				&::after {
					left: 3px;
					top: 0;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// cluster.vue?e42af61c